Vue.component("columnchart", {
  props: {
    data: { default: false, required: false },
    activeLabel: { default: false, required: false },
    removeLeadingCentury: { default: false, required: false }
    //columns: {default: ['yes', 'no']}
  },
  data() {
    return {
      chartid: "columnchart_" + makeID(),
      margin: { top: 30, right: 10, bottom: 10, left: 40 },
      fullWidth: 500,
      fullHeight: 400,
      svg: false,
      columns: ["yes", "no"],
      colors: [
        "#0055A2",
        "rgba(0, 85, 162, .2)",
        "#f5efe0",
        "#6eff42",
        "#429aff",
        "#ff5b42",
        "#7442ff",
        "#ffba42",
        "#ff426e",
        "#e67a6a"
      ],
      chartDrawn: false
    };
  },
  computed: {
    width() {
      return this.fullWidth - this.margin.left - this.margin.right;
    },
    height() {
      return this.fullHeight - this.margin.top - this.margin.bottom;
    },
    maxY() {
      if (!this.data) {
        return 100;
      }
      let max = false;
      for (let i = 0; i < this.data.length; i++) {
        for (const l in this.columns) {
          if (this.columns[l] == "label") {
            continue;
          }
          if (!max || this.data[i][this.columns[l]] > max) {
            max = this.data[i][this.columns[l]];
          }
        }
      }
      if (max * 1.1 < 100) {
        return max * 1.1;
      }
      return 100;
    }
    /*
        labels () {
            if (!this.data) {return false}
            let a = [];
            
        }*/
  },
  watch: {
    data(val) {
      if (val) {
        this.drawChart();
      }
    },
    activeLabel(val) {
      this.drawChart();
    }
  },
  mounted() {
    let $this = this;
  },
  methods: {
    getLabel(label) {
      if (this.removeLeadingCentury) {
        label = "'" + label.substring(2);
      }
      return label;
    },
    drawChart() {
      let $this = this;
      let data = $this.data;

      //TODO: MOVE THIS TO COMPUTED DATA, USE THIS.DATA
      let a = [];
      for (const d of data) {
        let l = $this.getLabel(d.label);

        a.push(l);
      }
      $this.labels = a;
      // TODO: END SECTION

      // TODO: MERGE INSTEAD OF REDRAW WHEN REDRAWN

      $this.x = d3.scaleBand().domain($this.labels).range([0, $this.width]).padding([0.2]);

      // TODO: DYNAMIC DOMAIN

      $this.y = d3.scaleLinear().domain([0, $this.maxY]).range([$this.height, 0]);

      $this.xSubgroup = d3
        .scaleBand()
        .domain($this.columns)
        .range([0, $this.x.bandwidth()])
        .padding([0.05]);

      $this.color = d3.scaleOrdinal().domain($this.columns).range($this.colors);
      if (!$this.chartDrawn) {
        $this.svg = d3.select("#" + $this.chartid + " svg");
        //  .attr("width", $this.width + $this.margin.left + $this.margin.right)
        //  .attr("height", $this.height + $this.margin.top + $this.margin.bottom)
        //$this.svg.attr("viewBox", [0, 0, this.width + $this.margin.right + $this.margin.left + 30, this.height + this.margin.top + this.margin.bottom + 20]);
        $this.svg.attr("viewBox", [
          0,
          0,
          this.fullWidth + $this.margin.right + $this.margin.left + 30,
          this.fullHeight + this.margin.top + this.margin.bottom + 20
        ]);
        $this.gw = $this.svg
          .append("g")
          .attr("transform", "translate(" + $this.margin.left + ", " + $this.margin.top + ")");

        $this.gw
          .append("g")
          .style("font-size", "11px")
          .attr("transform", "translate(0," + $this.height + ")")
          .call(d3.axisBottom($this.x).tickSize(0));

        $this.gw
          .append("g")
          .style("font-size", "11px")
          .call(
            d3.axisLeft($this.y).tickFormat(function (d) {
              return $this.formatData(d);
            })
          );

        $this.g = $this.gw.append("g");
      }

      $this.g
        .selectAll("g")
        .data(data)
        .join("g")
        //.enter()
        //.append("g")
        .attr("transform", function (d) {
          return "translate(" + $this.x($this.getLabel(d.label)) + ",0)";
        })
        .style("opacity", function (d) {
          return $this.getOpacity(d);
        })
        .attr("class", function (d) {
          if ($this.getOpacity(d) == 1) {
            return "highlight";
          } else {
            return;
          }
        })

        .selectAll("rect")
        .data(function (d) {
          return $this.columns.map(function (key) {
            return { key: key, value: d[key] };
          });
        })
        .join("rect")
        //.enter()
        //.append("rect")
        .attr("x", function (d) {
          return $this.xSubgroup(d.key);
        })
        .attr("y", function (d) {
          return $this.y(d.value);
        })
        .attr("width", $this.xSubgroup.bandwidth())
        .attr("height", function (d) {
          return $this.height - $this.y(d.value);
        })
        .attr("fill", function (d) {
          return $this.color(d.key);
        });

      /*  
            $this.svg
                .append("g")
                .selectAll("g")
                    .data(data)
                    .join("g")
                    .attr("transform", d => `translate(${x0(d.label)},0)`)
                    .selectAll("rect")
                    .data(d => $this.columns.map(key => ({key, value: d[key]})))
                    .join("rect")
                    .attr("x", d => x1(d.key))
                    .attr("y", d => y(d.value))
                    .attr("width", x1.bandwidth())
                    .attr("height", d => y(0) - y(d.value))
                    .attr("fill", d => color(d.key));

                    //.attr("transform","translate(" + $this.margin.left + "," + $this.margin.top + ")");

            

            /*
            d3.json(data).function(data) {
                let groups = 
            }
            */
      $this.chartDrawn = true;
    },
    getOpacity(d) {
      if (!this.activeLabel || d.label == this.activeLabel) {
        return 1;
      }
      return 0.5;
    },
    formatData(d) {
      // CURRENTLY ONLY FORMATTING PERCENTAGEs
      return d + "%";
    }
  }
});
